import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import RegistrationForm from './components/RegistrationForm';
import Receipt from './components/Receipt';
import VerificationPage from './components/VerificationPage';
import { ORG_LINE1, ORG_LINE2, PHOTO_PATH } from './constants';
import './App.css';

// Automatically detect local development server or production Cloudflare Worker API
const API = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:5000/api'
  : 'https://ustod-kamgar-api.aksharaj878.workers.dev/api';

function App() {
  const [page, setPage] = useState('login');
  const [user, setUser] = useState(null);
  const [registrationData, setRegistrationData] = useState(null);
  const [verifyAadhaar, setVerifyAadhaar] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const aadhaar = params.get('verify') || params.get('aadhaar');
    if (aadhaar) {
      setVerifyAadhaar(aadhaar);
      setPage('verify');
    } else {
      fetch(`${API}/auth/check-session`, { credentials: 'include' })
        .then((res) => res.json())
        .then((data) => {
          if (data.loggedIn) {
            setUser(data.user);
            setPage('dashboard');
          }
        })
        .catch(() => {});
    }
  }, []);

  const handleLogin = async (username, password) => {
    const res = await fetch(`${API}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ username, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error);
    setUser(data.user);
    setPage('dashboard');
  };

  const handleLogout = async () => {
    await fetch(`${API}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
    setUser(null);
    setPage('login');
  };

  const handleSubmitRegistration = async (formData) => {
    const res = await fetch(`${API}/registration/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(formData),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error);
    setRegistrationData(data.data);
    setPage('receipt');
  };

  const handleNewRegistration = () => {
    setRegistrationData(null);
    setPage('registration');
  };

  const handleGoToDashboard = () => {
    setRegistrationData(null);
    setPage('dashboard');
  };

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-content">
          <img
            src={PHOTO_PATH}
            alt="Gopinath Munde"
            className="header-photo"
          />
          <div className="header-text">
            <h1 className="header-title">{ORG_LINE1}</h1>
            <p className="header-subtitle">{ORG_LINE2}</p>
          </div>
          {user && page !== 'verify' && (
            <div className="header-user">
              <span className="user-badge">{user.contact}</span>
              <button className="btn-logout" onClick={handleLogout}>Logout / लॉगआउट</button>
            </div>
          )}
        </div>
      </header>

      <main className="app-main">
        {page === 'login' && <Login onLogin={handleLogin} />}
        {page === 'dashboard' && <Dashboard onNewRegistration={handleNewRegistration} onLogout={handleLogout} user={user} API={API} />}
        {page === 'registration' && (
          <RegistrationForm onSubmit={handleSubmitRegistration} onCancel={() => setPage('dashboard')} API={API} />
        )}
        {page === 'receipt' && (
          <Receipt
            data={registrationData}
            onNewRegistration={handleNewRegistration}
            onLogout={handleLogout}
            onGoToDashboard={handleGoToDashboard}
          />
        )}
        {page === 'verify' && (
          <VerificationPage aadhaar={verifyAadhaar} API={API} />
        )}
      </main>

      <footer className="app-footer">
        <p>&copy; 2026 {ORG_LINE2}. All rights reserved. / सर्व हक्क राखीव.</p>
      </footer>
    </div>
  );
}

export default App;
